/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./VIPRDecoratable',
	'../../../widgets/livewidget/nls/StringResources',
	'../../../apiHelpers/SlotAPIHelper'
], function(VIPRDecoratable, StringResources, SlotAPIHelper) {

	// implements IItemClass
	class VIPRItemClass extends VIPRDecoratable {
		constructor(dataItem, context) {
			super(...arguments);

			this.dataItem = dataItem;
			this.context = context;
		}

		destroy() {
			this.context = null;
		}

		getUniqueName() {
			return this.dataItem.getColumnId();
		}

		getCaption() {
			let summaryStr;
			if (!this.context.hideAggTypeInAxisLabels) {
				const aggregate = this.dataItem.getAggregation() || 'none';
				summaryStr = aggregate !== 'none' ? ' (' + StringResources.get(aggregate) + ')' : null;
			}
			let caption = this.dataItem.getLabel();
			if (this.getUniqueName() === SlotAPIHelper.MULTI_MEASURES_SERIES) {
				caption = StringResources.get('MeasuresCaption');
			}
			return summaryStr ? caption + summaryStr : caption;
		}
	}

	return VIPRItemClass;
});